import {
    FETCH_REVIEW_REQUEST,
    FETCH_REVIEW_SUCCESS,
    FETCH_REVIEW_FAILURE,
    
  } from "../actions/review.js";
  
  export default function review(state = {
    isFetching: false,
    errorMessage: '',
    reviewData:[]
  }, action) {
    switch (action.type) {
      case FETCH_REVIEW_REQUEST:
        return Object.assign({}, state, {
          isFetching: true,
        });
      case FETCH_REVIEW_SUCCESS:
        return Object.assign({}, state, {
          isFetching: false,
          errorMessage: '',
          reviewData: action.payload
        });
      case FETCH_REVIEW_FAILURE:
        return Object.assign({}, state, {
          isFetching: false,
          errorMessage: action.payload,
        });

        
      default:
        return state;
    }
  }